import { AppStoreBadges } from './AppStoreBadges';

const HERO_IMG = "https://static.prod-images.emergentagent.com/jobs/eb0b6cb2-5b67-4a48-8f09-a50dd555aaf3/images/71e2f692771d80cea8bbea14b626803e6246603727dbdca41ff12da6c61dfac8.png";

export const HeroSection = () => (
  <section className="relative overflow-hidden" data-testid="hero-section">
    <div className="absolute inset-0">
      <img src={HERO_IMG} alt="Scales of Justice" className="w-full h-full object-cover" />
      <div className="absolute inset-0 bg-gradient-to-r from-background via-background/90 to-background/60 dark:from-background dark:via-background/95 dark:to-background/70" />
    </div>
    <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 sm:py-28 lg:py-36">
      <div className="max-w-2xl">
        <div className="flex items-center gap-3 mb-6 opacity-0 animate-fade-in-up">
          <img src="/logo.png" alt="VerdictIQ" className="h-16 w-16 object-contain" />
          <span className="text-xs sm:text-sm uppercase tracking-[0.2em] font-sans font-semibold text-muted-foreground">
            AI-Powered Dispute Resolution
          </span>
        </div>
        <h1 className="text-4xl sm:text-5xl lg:text-6xl tracking-tight font-serif font-bold leading-tight opacity-0 animate-fade-in-up delay-100" data-testid="hero-title">
          Every Argument<br />Deserves a{' '}
          <span className="text-primary">Fair Verdict</span>
        </h1>
        <p className="mt-6 text-base sm:text-lg leading-relaxed text-muted-foreground max-w-xl opacity-0 animate-fade-in-up delay-200">
          Submit both sides of your relationship dispute and let our AI judge deliver an impartial analysis, determine fault, and provide a constructive path forward.
        </p>
        <div className="mt-8 opacity-0 animate-fade-in-up delay-300">
          <p className="text-xs uppercase tracking-[0.2em] font-sans font-semibold text-muted-foreground mb-3">Get the app</p>
          <AppStoreBadges idSuffix="hero" />
        </div>
      </div>
    </div>
  </section>
);
